import { useState } from 'react'
import { useProjectPermissions } from 'hooks/useProjectPermissions'
import Button from 'ui/components/buttons/Button'
import {
  WrapperStyled,
  LinkNotPublished,
  PublishedButtonWrap,
  EmptyButtonWrap,
} from './styled'
import { VIEW_MODE } from '../../constants'

const LinkSection = ({
  hasLink,
  renderForm,
  renderPublished,
  emptyText,
  addTitle,
  editTitle,
}) => {
  const { isManagerOrAdmin } = useProjectPermissions()

  const [mode, setMode] = useState(VIEW_MODE.VIEW)

  const openForm = () => setMode(VIEW_MODE.FORM)
  const closeForm = () => setMode(VIEW_MODE.VIEW)

  if (mode === VIEW_MODE.FORM) {
    return <WrapperStyled>{renderForm({ onCancel: closeForm })}</WrapperStyled>
  }

  return (
    <>
      <WrapperStyled>
        {hasLink ? (
          <>
            {renderPublished()}
            {isManagerOrAdmin && (
              <PublishedButtonWrap>
                <Button title={editTitle} onClick={openForm} />
              </PublishedButtonWrap>
            )}
          </>
        ) : (
          <>
            <LinkNotPublished>{emptyText}</LinkNotPublished>
            {isManagerOrAdmin && (
              <EmptyButtonWrap>
                <Button title={addTitle} onClick={openForm} />
              </EmptyButtonWrap>
            )}
          </>
        )}
      </WrapperStyled>
    </>
  )
}

export default LinkSection
